(() => {
  const containerSelector = '[data-grow-product-description]';
  const contentSelector = '[data-grow-product-description-content]';
  const toggleSelector = '[data-grow-product-description-toggle]';

  const syncButtonState = (button, expanded) => {
    button.textContent = expanded ? button.dataset.lessLabel || 'Hide' : button.dataset.moreLabel || 'Read more';
    button.setAttribute('aria-expanded', String(expanded));
  };

  const needsToggle = (container) => {
    const content = container.querySelector(contentSelector);
    if (!content) return false;

    const previousState = container.dataset.expanded;
    container.dataset.expanded = 'false';

    const contentChildren = Array.from(content.children).filter((child) => child.textContent.trim() !== '');
    const firstChild = contentChildren[0];
    const hasAdditionalContent = contentChildren.length > 1;
    const isClamped = firstChild ? firstChild.scrollHeight > firstChild.clientHeight + 1 : false;

    container.dataset.expanded = previousState === 'true' ? 'true' : 'false';
    return hasAdditionalContent || isClamped;
  };

  const updateContainer = (container) => {
    const button = container.querySelector(toggleSelector);
    if (!button) return;

    const expanded = container.dataset.expanded === 'true';
    const showToggle = needsToggle(container);

    button.hidden = !showToggle;

    if (!showToggle) {
      container.dataset.expanded = 'true';
      syncButtonState(button, true);
      return;
    }

    syncButtonState(button, expanded);
  };

  const updateAll = (root = document) => {
    root.querySelectorAll(containerSelector).forEach(updateContainer);
  };

  const requestUpdate = (root = document) => {
    window.requestAnimationFrame(() => updateAll(root));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(toggleSelector);
    if (!button) return;

    const container = button.closest(containerSelector);
    if (!container) return;

    event.preventDefault();
    container.dataset.expanded = container.dataset.expanded === 'true' ? 'false' : 'true';
    updateContainer(container);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => requestUpdate(), { once: true });
  } else {
    requestUpdate();
  }

  window.addEventListener('load', () => requestUpdate());
  window.addEventListener('resize', () => requestUpdate());
  document.addEventListener('shopify:section:load', (event) => requestUpdate(event.target));
  document.addEventListener('shopify:section:reorder', () => requestUpdate());
  document.addEventListener('shopify:section:select', (event) => requestUpdate(event.target));
})();
